import { Accessibility } from 'chessboard/plugins/accessibility/config/types';
import { Core } from 'chessboard/core/config/types';
import { is } from 'src/utils/app/model/is';
import type { Plugins } from 'chessboard/core/plugins/config/types';

/**
 * Create the accessibility plugin to provide functionality to users with various
 * accessibility issues.
 */
export function createAccessibilityPlugin(
  rightClickModifier = Accessibility.DefaultRightClickModifierKey,
): Plugins.Model {
  return {
    beforeState: [
      {
        condition: is(Core.UserEvents.PointerdownLeft),
        handler: convertToPointerdownRightIfModifierKeyPressed,
      },
    ],
    name: Accessibility.Plugin.Name,
    requires: ['keys'],
  };

  /**
   * Convert a PointerdownLeft event to a PointerdownRight event if the
   * rightClickModifier key is pressed.
   */
  function convertToPointerdownRightIfModifierKeyPressed(
    event: Core.Event,
    context: Core.Context,
  ): boolean {
    const { api, queue, run } = context;

    if (api.keys.isPressed(rightClickModifier)) {
      queue.add(run, { ...event, type: Core.UserEvents.PointerdownRight });

      return false;
    }

    return true;
  }
}
